import { ReactNode } from "react";
import naep_logo from '../assets/naep_logo.svg';
import { Columns, Column, Box, Image } from "@enaep-ng/benchmark";

interface SplitLayoutProps {
  children: ReactNode;
  alignment?: "center" | "left";
}

export function SplitLayout({children, alignment}: SplitLayoutProps) {

  return (
    <Box sx={{
      display: 'block',
      justifyItems: 'center',
      lineHeight: 1.3,
      margin: "calc(30px * var(--zoom)) auto",
      overflow: 'auto'
    }}>
      <Box>
        <Columns sx={{ alignItems: 'center'}}>
          <Column style={{flex: "20%"}}>
            <Box sx={{
              position: 'relative',
              height: 'calc(100vh - calc(202px * var(--zoom)))',
              width: 'calc(432px * var(--zoom))',
              float: 'right',
              "::after": {
                content: '""', 
                position: 'absolute',
                right: 0, 
                top: "50%", 
                borderRight: "solid calc(2px * var(--zoom))",
                borderColor: 'p.500',
                transform: "translateY(-50%)",
                height: 'calc(450px * var(--zoom))',
              }
            }}>
              <Box sx={{
                position: "absolute",
                top: "55%",
                right: "calc(65px * var(--zoom))",
                transform: "translateY(-50%)",
                maxWidth: "calc(172px * var(--zoom))",
                height: "auto"
              }}>
                <Image 
                  imgWidth={165}
                  src={naep_logo} 
                />
              </Box>
            </Box>
          </Column>
          <Column style={{flex: "70%"}}>
            <Box sx={{
              textAlign: `${alignment !== undefined ? alignment : "center"}`,
              fontFamily: '"OpenSans-Regular", "Open Sans", sans-serif',
              paddingLeft: `${alignment !== undefined ? 'calc(44px * var(--zoom))' : 0}`,
              // paddingTop: "calc(48px * var(--zoom))",
              // paddingBottom: "calc(44px * var(--zoom))",
            }}>
              {children}
            </Box>
          </Column>
          <Column style={{flex: "10%"}}></Column>
           
        </Columns>
      </Box>
    </Box>
  )

  // return (
  //   // Maybe wrap this in a full height div then vertically center it.
  //   <div style={{
  //     display: "flex",
  //     margin: "30px 0",
  //     height: 'calc(100vh - 192px)',
  //     overflow: 'scroll'
  //   }}>
  //     <div style={{
  //       flex: "30%",
  //       position: "relative",
  //       borderRight: "solid 2px #509bdf"
  //     }}>
  //       <img src={naep_logo} style={{
  //         position: "absolute",
  //         top: "50%",
  //         right: "34px",
  //         transform: "translateY(-50%)",
  //         maxWidth: "172px",
  //         height: "auto"
  //       }} />
  //     </div>
  //     <div style={{
  //       flex: "70%"
  //     }}>
  //       <div style={{
  //         display: "inline",
  //         textAlign: `${alignment !== undefined ? alignment : "center"}`,
  //         fontFamily: '"OpenSans-Regular", "Open Sans", sans-serif'
  //       }}>
  //         {children}  
  //       </div>
  //     </div>
  //   </div>
  // )
}